import {useEffect, useRef} from "react";
import {useTranslation} from "react-i18next";
import ApiService from "../../core/service/api-service";
import {Button, Checkbox, Form, Input, Switch} from "antd";

export default function RequestTypeCreateEdit({modalityId, requestType, onSaved})
{
    const formRef = useRef();
    const {t} = useTranslation();

    const save = async (form) => {
        if(requestType.id)
        {
            const response = await ApiService.RequestType.Edit(modalityId, requestType.id, form);
            if(response.success)
                onSaved && onSaved(response.data)
        }
        else
        {
            const response = await ApiService.RequestType.Create(modalityId, form);
            if(response.success)
                onSaved && onSaved(response.data)
        }
    }

    useEffect(() => {
        console.log('modalityId changed', modalityId);
    }, [modalityId])

    return (
        <>
            <Form
                layout={'vertical'}
                onFinish={save}
                ref={formRef}
                initialValues={{...requestType}}
            >
                <Form.Item
                    label={t('Name')}
                    name={'name'}
                    rules={[
                        {required: true}
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label={t('Display Name')}
                    name={'displayName'}
                    rules={[
                        {required: true}
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label={t('Sut Code')}
                    name={'sutCode'}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label={t('Loinc Code')}
                    name={'loincCode'}
                >
                    <Input />
                </Form.Item>

                <Form.Item label="" name="visible" valuePropName="checked">
                    <Checkbox>Visible</Checkbox>
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        {t('Save')}
                    </Button>
                </Form.Item>
            </Form>
        </>
    )
}
